import React, { useEffect, useState } from 'react';
import useStore from '../../useStore';
import logo from "../../assests/imagenes/La_Romana_logo_completo_negro.svg";
import styles from './Header.module.css';
import { obtenerPerfil } from '../../repositorios/apiServer';

const Header = () => {
  const userToken = useStore((state) => state.userToken);
  const [userData, setUserData] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    const cargarPerfil = async () => {
      if (userToken) {
        try {
          setCargando(true);
          const perfilData = await obtenerPerfil(userToken);
          
          if (perfilData && perfilData.user) {
            setUserData(perfilData.user);
          }
        } catch (error) {
          console.error("Error al cargar perfil en header:", error);
          setUserData(null);
        } finally {
          setCargando(false);
        }
      } else {
        setUserData(null);
      }
    };

    cargarPerfil();
  }, [userToken]);

  return (
    <section className={styles.header_section}>
      <div className={styles.div_header}> 
        <div className={styles.welcome_container}> 
          {userData && (
            <div className={styles.user_name}>
              <div className={styles.welcome_text}>Bienvenido</div> 
              <div>{userData.nombre}</div>
            </div>
          )}  
          {!userData && !cargando && (
            <div className={styles.user_name}>
              <div className={styles.welcome_text_not_client}>Carta</div>
            </div>
          )}
          {cargando && (
            <div className={styles.user_name}>
              <div className={styles.welcome_text}>Cargando...</div>
            </div>
          )}
        </div>
        <div className={styles.div_logo}>
          <img src={logo} alt="Logo La Romana" className={styles.logo_image} />
        </div>
      </div>
    </section>
  );
};

export default Header;